import { TimeMaterialBoardResponse } from '@business/entities/tm/TimeMaterialBoardResponse';
import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { showDeleteConfirmation } from '@modules/common';
import { switchMap } from 'rxjs/operators';
import { TMRMADamageStatusAPI } from '@business/api/tm_rma_damage_status';

export class TMRMADamageStatusBloc extends BaseBloc {
  private readonly boardRepo = new Repository<TimeMaterialBoardResponse>({
    getItemId: board => board.id,
    pagenated: true,
  });

  readonly items$ = this.boardRepo.items$;
  readonly selectStatus = this.boardRepo.selectItem;

  onReset() {
    this.boardRepo.reset();
  }

  fetchStatuses = (permission = true) => {
    return TMRMADamageStatusAPI.fetchStatuses(permission).pipe(
      this.boardRepo.ops.reset(),
      handleMessage({ error: requestMessage('fetch_rma_status_error') }),
    );
  };

  createStatus = (data: Partial<TimeMaterialBoardResponse>) => {
    return TMRMADamageStatusAPI.createStatus(data).pipe(
      this.boardRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_rma_status'),
      }),
    );
  };

  updateStatus = (id: string, data: Partial<TimeMaterialBoardResponse>) => {
    return TMRMADamageStatusAPI.updateStatus(id, data).pipe(
      this.boardRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_rma_status'),
      }),
    );
  };

  deleteStatus = (id: string) => {
    return showDeleteConfirmation('Delete Status', 'Do you really want to remove this status?').pipe(
      switchMap(() => TMRMADamageStatusAPI.deleteStatus(id)),
      this.boardRepo.ops.removeOne(() => id),
      handleMessage({
        type: requestMessage('delete_rma_status'),
      }),
    );
  };
}
